//@flow

import React, { CSSPropertiess } from "react";

type Props = $Exact<{
  children: string,
  text: string,
  lineHeight?: string | number,
  type?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p" | "pre" | "strong",
  size?: number,
  tooltip?: string,
  title?: string,
  html?: HTMLElement,
  style?: CSSPropertiess,
  weight?:
    | "normal"
    | "bold"
    | "100"
    | "200"
    | "300"
    | "400"
    | "500"
    | "600"
    | "700"
    | "800"
    | "900"
    | "lighter"
    | "bolder"
    | "inherit"
    | "initial"
    | "revert"
    | "revert-layer"
    | "unset",

  className?: string,
  color?:
    | "blue"
    | "indigo"
    | "purple"
    | "pink"
    | "red"
    | "orange"
    | "yellow"
    | "green"
    | "teal"
    | "cyan"
    | "white"
    | "gray"
    | "gray-dark"
    | "primary"
    | "secondary"
    | "success"
    | "info"
    | "warning"
    | "danger"
    | "light"
    | "dark"
    | "body-bg"
    | "transparent "
    | "white"
    | "lighter-grey"
    | "very-light-pink-two"
    | "disabled-input"
    | "light-grey"
    | "grey"
    | "disabled-light"
    | "charcoal-light"
    | "pinkish-grey"
    | "dark-grey"
    | "disabled"
    | "disabled-light07"
    | "greyish-brown"
    | "greyish-brown-05"
    | "chatbubble-background"
    | "charcoal"
    | "charcoal-dark"
    | "black"
    | "not-so-black"
    | "dark-green"
    | "ocean-green"
    | "light-green"
    | "positive"
    | "orange"
    | "magenta"
    | "purple"
    | "navy"
    | "blue"
    | "clear-blue"
    | "clear-blue-light"
    | "green"
    | "pumpkin-orange"
    | "dusty-orange"
    | "attention"
    | "negative"
    | "red"
    | "warning-light"
    | "accent-active"
    | "yellow"
    | "coffee"
    | "coffee-d1"
    | "coffee-d2"
    | "coffee-d3"
    | "light-coffee"
    | "mint-light"
    | "mint"
    | "mint-d1"
    | "mint-d2"
    | "mint-d3"
    | "berry"
    | "berry-d1"
    | "berry-d2"
    | "berry-d3"
    | "ice"
    | "ice-d1"
    | "ice-d2"
    | "ice-d3"
    | "risk-very-low"
    | "risk-low"
    | "risk-medium"
    | "risk-high"
    | "risk-very-high"
    | "rose"
    | "gs-grid-row-hover"
    | "weekend"
    | "holiday"
    | "rose-d1",
}>;

export function Text(props: Props) {
  let className = (props.className || "").split(" ");
  const style: CSSPropertiess = { props };

  if (props.size) style.fontSize = `${props.size}rem`;
  if (props.weight) style.fontWeight = props.weight;
  if (props.color) style.color = `var(--${props.color})`;
  if (props.lineHeight)
    style.lineHeight =
      typeof props.lineHeight === "number" ? `${props.lineHeight * 4}px` : props.lineHeight;

  const elProps = {
    className: className.join(" "),
    title: props.tooltip || props.title || null,
    style,
  };

  if (props.hasOwnProperty("html"))
    return React.createElement(props.type || "div", {
      ...elProps,
      dangerouslySetInnerHTML: { __html: props.html },
    });
  else return React.createElement(props.type || "div", elProps, props.text || props.children);
}
